// extracted by mini-css-extract-plugin
export default {"graphTitle":"SaveValuesTab_graphTitle__e0WFG","titleBox":"SaveValuesTab_titleBox__Bgj8R","helpBlock":"SaveValuesTab_helpBlock__mhLQE"};